var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import "core-js/modules/es.array.fill.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
import styled, { css } from 'styled-components';
import { getFont } from '@finect/tabular-utils/getFont';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { animationPop } from './animationPop';
import { Count } from './Count';
var getColor = function getColor(theme, color) {
  if (color === 'primary') return theme.mainColor;
  if (color === 'success') return theme.colors.positive;
  return theme.secondaryColor;
};
var doneStyles = css(["color:", ";svg{fill:", ";stroke:", ";", ";}"], function (_ref) {
  var theme = _ref.theme,
    color = _ref.color;
  return color ? getColor(theme, color) : theme.colors.font;
}, function (_ref2) {
  var theme = _ref2.theme,
    color = _ref2.color,
    fill = _ref2.fill;
  return fill || (color ? getColor(theme, color) : theme.colors.font);
}, function (_ref3) {
  var theme = _ref3.theme,
    color = _ref3.color;
  return color ? getColor(theme, color) : theme.colors.font;
}, animationPop);
var disabledStyles = css(["cursor:not-allowed;&:hover{color:", ";}"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.fontL;
});
export var Action = styled.div.withConfig({
  displayName: "Action",
  componentId: "sc-hd6yln-0"
})(["display:flex;align-items:center;margin:6px 24px 6px 0;cursor:pointer;", ";white-space:nowrap;color:", ";transition:color 0.15s ease;svg{flex-shrink:0;width:18px;height:18px;}span{margin-left:5px;}&:last-child{margin-right:0;}&:hover{color:", ";", "{", ";}}", ";", ";", ";"], getFont(-1, 'compact'), function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.fontL;
}, function (_ref6) {
  var theme = _ref6.theme,
    color = _ref6.color;
  return color ? getColor(theme, color) : theme.colors.font;
}, Count, function (_ref7) {
  var theme = _ref7.theme,
    color = _ref7.color,
    solved = _ref7.solved;
  return solved ? "background-color: ".concat(color ? getColor(theme, color) : theme.colors.font) : null;
}, maxMediaQueries.phone(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    margin-right: 18px;\n\n    span {\n      display: none;\n    }\n\n    svg {\n      width: 20px;\n      height: 20px;\n    }\n  "]))), function (_ref8) {
  var done = _ref8.done;
  return done && doneStyles;
}, function (_ref9) {
  var disabled = _ref9.disabled;
  return disabled && disabledStyles;
});